import { ApiHelper, IApiResponse } from "../../utils/api-helper";

const url = `${process.env.REACT_APP_API_ENDPOINT}/Proposals`;

class ProposalService extends ApiHelper {
  constructor(_url: string) {
    super(_url);
  }

  public getProposalPlanList(body: any): Promise<IApiResponse | void> {
    try {
      // return super.create(body, { name: "list" });
      return super.create(body, { name: "planstatuslist" });
    } catch (e) {
      throw e;
    }
  }

  public getProposal(id: any): Promise<IApiResponse | void> {
    try {
      return super.getById(id);
    } catch (e) {
      throw e;
    }
  }

  public createProposal(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body);
    } catch (e) {
      throw e;
    }
  }

  public removeProposalPlan(id: number): Promise<IApiResponse | void> {
    try {
      return super.delete(id);
    } catch (e) {
      throw e;
    }
  }
  public removePlanFromProposal(path: string): Promise<IApiResponse | void> {
    try {
      return super.delete(path);
    } catch (e) {
      throw e;
    }
  }

  public addPlan(
    proposalId: number,
    planId: number
  ): Promise<IApiResponse | void> {
    try {
      return super.update(undefined, proposalId, { name: "plan", id: planId });
    } catch (e) {
      throw e;
    } finally {
      this.url = url;
    }
  }

  public updateProposal(
    body: any,
    qs?: string
  ): Promise<IApiResponse | void> {
    let tempUrl = qs ? `updatestatus${qs ? "?" + qs : ""}` : "updatestatus";
    try {
      return super.update(body, tempUrl);
    } catch (e) {
      throw e;
    } finally {
      this.url = url;
    }
  }
  // public getNewDebtPlanDetail(planId: number): Promise<IApiResponse | void> {
  //   try {
  //     this.url = mockUpEndPoint;
  //     return super.getById(planId);
  //   } catch (e) {
  //     throw e;
  //   } finally {
  //     this.url = url;
  //   }
  // }

  // public getNewDebtPlanSummary(id: number, queries: any): Promise<IApiResponse | void> {
  //     try {
  //         return super.getById(id, { name: "summary" }, queries);
  //     } catch (e) {
  //         throw e;
  //     }
  // }

  // public getNewDebtPlanBody(body: any): Promise<IApiResponse | void> {
  //     try {
  //         return super.create(body, { name: "projectlist" });
  //     } catch (e) {
  //         throw e;
  //     }
  // }

  // public modifyLoanSources(planId: number, ProjectID: number, body: any): Promise<IApiResponse | void> {
  //     try {
  //         this.url = `${this.url}/${planId}/Projects`;
  //         return super.createById(body, ProjectID, { name: "loansources" });
  //     } catch (e) {
  //         throw e;
  //     } finally {
  //         this.url = url;
  //     }
  // }

  // public addProjectToPlan(planId: number, ProjectID: number, queries: any): Promise<IApiResponse | void> {
  //     try {
  //         this.url = `${this.url}/${planId}/project`;
  //         return super.update(undefined, ProjectID, undefined, queries);
  //     } catch (e) {
  //         throw e;
  //     } finally {
  //         this.url = url;
  //     }
  // }

  // public removeProjectFromPlan(planId: number, ProjectID: number, queries: any): Promise<IApiResponse | void> {
  //     try {
  //         this.url = `${this.url}/${planId}/project`;
  //         return super.delete(ProjectID, queries);
  //     } catch (e) {
  //         throw e;
  //     } finally {
  //         this.url = url;
  //     }
  // }
}
const proposalAPI = new ProposalService(url);
export default proposalAPI;
